import wx from 'weixin-js-sdk';
// eslint-disable-next-line no-unused-vars
import { get,post } from "../api/http";
import store from "@/store/store";

// 调起微信支付
export function payAwaken(data) {
    wx.ready(function () {
        wx.chooseWXPay({
            timestamp: data.timestamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
            nonceStr: data.nonceStr, // 支付签名随机串，不长于 32 位
            package: data.prepayId, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=***）
            signType: data.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
            paySign: data.paySign, // 支付签名
            success: function (res) {
                console.log(`微信支付结果${res}`)

                store.commit("setWxapy",0)

                // 支付成功回调
            },
            cancel: function(err) {
                // 支付取消回调函数
                console.log(err);

                store.commit("setWxapy",1)
            },
            fail: function (res) {
                // 支付失败回调函数
                console.log(res)

                store.commit("setWxapy",2)
            }
        });
    })
    // let url = window.location.href.split("#")[0];
    //     get("/wx/signature",{url: url})
    //         .then(res => {
    //             console.log(res)
    //             if(res) {
    //                 // 配置微信api
    //                 wx.config({
    //                     debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    //                     appId: process.env.VUE_APP_AppID, // 必填，公众号的唯一标识
    //                     timestamp: res.data.timestamp, // 必填，生成签名的时间戳
    //                     nonceStr: res.data.noncestr,   // 必填，生成签名的随机串
    //                     signature: res.data.signature, // 必填，签名，见附录1
    //                     jsApiList: ["chooseWXPay"]
    //                 });
    //                 wx.ready(function () {
    //                     wx.chooseWXPay({
    //                         timestamp: data.timestamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
    //                         nonceStr: data.nonceStr, // 支付签名随机串，不长于 32 位
    //                         package: data.prepayId, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=***）
    //                         signType: data.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
    //                         paySign: data.paySign, // 支付签名
    //                         success: function (res) {
    //                             console.log(`微信支付结果${res}`)
    //
    //                             store.commit("setWxapy",0)
    //
    //                             // 支付成功回调
    //                         },
    //                         cancel: function(err) {
    //                             // 支付取消回调函数
    //                             console.log(err);
    //
    //                             store.commit("setWxapy",1)
    //                         },
    //                         fail: function (res) {
    //                             // 支付失败回调函数
    //                             console.log(res)
    //
    //                             store.commit("setWxapy",2)
    //                         }
    //                     });
    //                 })
    //
    //             }
    //         })



}
